<template>
  <section class="segment orange" v-if="items.length">
    <div class="row column tac">
      <p class="h2 black background text-white" v-text="heading"></p>
    </div>
    <div
      class="row large-up-4 medium-up-2 small-up-1 tiny-up-1 grid-image flex radius margin non-even background-image"
    >
      <div class="column" v-for="item in items" :key="item.id">
        <a :href="item.url" class="box">
          <span class="image" :style="style(item.image)">
            <img
              src="/assets/images/front/widget/cross-reference.png"
              :alt="item.title"
            />
          </span>
          <span class="caption">
            <span class="heading" v-text="item.title"></span>
            <small v-text="item.type"></small>
          </span>
        </a>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'CrossReference',
  data() {
    return {
      heading: 'RELATED NEWS',
      items: {
        type: Array,
        default: [],
      },
      route: '/widget/cross-reference',
    };
  },
  created() {
    if (window.location.pathname === '/') {
      this.heading = 'TOP STORIES';
    }
  },
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      let tag = window.$('meta[name="keywords"]');
      if (tag.length === 0) {
        return;
      }
      window.axios
        .post(this.route, { tags: tag.attr('content') })
        .then(this.success)
        .catch(this.failure);
    },
    success(response) {
      this.items = response.data;
    },
    failure(error) {
      console.log(error);
    },
    style(paths) {
      return "background-image: url('" + paths.medium + "');";
    },
  },
};
</script>
